import axios from "axios";
import { getToken } from "../../common/commonFunctions";
// import { isAuthenticated } from "@/common/commonFunctions";

const state = () => ({
  ownGroups: [],
  userGroups: [],
  group: null,
  groupUsers: [],
  groupUsersMeta: {
    totalPages: 1,
    pagesLoaded: 0,
  },
  groupTrades: [],
  groupTradesMeta: {
    totalPages: 1,
    pagesLoaded: 0,
  },
  groupParticipants: [],
  groupParticipantsMeta: {
    totalPages: 1,
    pagesLoaded: 0,
  },
  updates: [],
});

const getters = {
  groupTradesHasMorePage(state) {
    const meta = state.groupTradesMeta;
    return meta.totalPages > meta.pagesLoaded;
  },

  groupUsersHasMorePage(state) {
    const meta = state.groupUsersMeta;
    return meta.totalPages > meta.pagesLoaded;
  },

  groupParticipantsHasMorePage(state) {
    const meta = state.groupParticipantsMeta;
    return meta.totalPages > meta.pagesLoaded;
  },
};

const actions = {
  toggleGroupModal({ commit }, obj) {
    commit("TOGGLE_GROUP_MODAL", obj);
  },
  async createGroup(
    { commit, dispatch },
    { name, disclaimer, logo, participants, addAll }
  ) {
    const fd = new FormData();
    fd.set("name", name);
    fd.set("disclaimer", disclaimer);

    if (logo) fd.set("picture", logo);
    if (participants) {
      for (const p of participants) fd.append("participants", p);
    }
    let headers = {};
    headers["Authorization"] = `Bearer ${getToken()}`;
    let config = {};
    config["headers"] = headers;

    const group = (await axios.post("/api/own-groups/", fd, config)).data;
    commit("addOwnGroup", group);

    if (addAll) await dispatch("addAllFollowers", { groupId: group.id });
  },

  async editGroup(
    { commit, dispatch },
    { id, name, logo, disclaimer, participants, addAll }
  ) {
    const fd = new FormData();
    fd.set("name", name);
    fd.set("disclaimer", disclaimer);
    let headers = {};
    headers["Authorization"] = `Bearer ${getToken()}`;
    let config = {};
    config["headers"] = headers;

    if (logo) fd.set("picture", logo);
    if (participants) {
      for (const p of participants) fd.append("participants", p);
    }

    const group = (await axios.put(`/api/own-groups/${id}/`, fd, config)).data;
    commit("updateOwnGroup", group);

    if (addAll) await dispatch("addAllFollowers", { groupId: group.id });
  },

  async fetchOwnGroups({ commit }) {
    let headers = {};
    headers["Authorization"] = `Bearer ${getToken()}`;
    let config = {};
    config["headers"] = headers;
    const groups = (await axios.get("/api/own-groups/", config)).data;
    commit("setOwnGroups", groups);
  },

  async fetchUserGroups({ commit }, { userId }) {
    let headers = {};
    let access = localStorage.getItem("access");

    if (access) {
      headers["Authorization"] = `Bearer ${getToken()}`;
    } else {
      headers["Authorization"] = ``;
    }
    // console.log('get token', getToken());
    // headers["Authorization"] = ``;

    let config = {};
    config["headers"] = headers;
    const groups = (await axios.get(`/api/user-groups/${userId}/`, config))
      .data;
    commit("setUserGroups", groups);
  },

  async fetchGroup({ commit }, { groupId }) {
    let headers = {};
    headers["Authorization"] = `Bearer ${getToken()}`;
    let config = {};
    config["headers"] = headers;
    const group = (await axios.get(`/api/groups/${groupId}/`, config)).data;
    commit("setGroup", group);
  },

  async joinGroup({ commit, state }, { utmSource } = { utmSource: null }) {
    let headers = {};
    headers["Authorization"] = `Bearer ${getToken()}`;
    let config = {};
    config["headers"] = headers;
    let url = `/api/groups/${state.group.id}/join/`;
    if (utmSource) url = `${url}?utm_source=${utmSource}`;
    await axios.post(url, {}, config);
    commit("setGroupParticipationStatusTrue");
  },
  setGroupAfterJoin({ commit }, obj) {
    commit("setGroupParticipationStatusTrue", obj);
  },
  setGroupRequest({ commit }, obj) {
    commit("setGroupIsRequest", obj);
  },
  async leaveGroup({ commit, state }) {
    let headers = {};
    headers["Authorization"] = `Bearer ${getToken()}`;
    let config = {};
    config["headers"] = headers;
    await axios.post(`/api/groups/${state.group.id}/leave/`, {}, config);
    commit("setGroupParticipationStatusFalse");
  },

  async deleteGroup({ commit, state }) {
    let headers = {};
    headers["Authorization"] = `Bearer ${getToken()}`;
    let config = {};
    config["headers"] = headers;
    await axios.delete(`/api/own-groups/${state.group.id}/`, config);
    commit("removeOwnGroup", state.group.id);
  },

  async fetchGroupTrades({ commit, state }, { groupId }) {
    let headers = {};
    headers["Authorization"] = `Bearer ${getToken()}`;
    let config = {};
    config["headers"] = headers;
    if (!getters.groupTradesHasMorePage) return;
    const page = state.groupTradesMeta.pagesLoaded + 1;
    const data = (
      await axios.get(`/api/groups/${groupId}/trades/?page=${page}`, config)
    ).data;
    commit("appendGroupTrades", data.results);
    commit("setGroupTradesMeta", {
      totalPages: Math.ceil(data.count / process.env.VUE_APP_PAGE_SIZE),
      pagesLoaded: page,
    });
  },

  async fetchGroupUsers({ commit, state }) {
    let headers = {};
    headers["Authorization"] = `Bearer ${getToken()}`;
    let config = {};
    config["headers"] = headers;
    if (!getters.groupUsersHasMorePage) return;
    const page = state.groupUsersMeta.pagesLoaded + 1;
    const search_query = state.groupUsersMeta.search_query;

    const data = (
      await axios.get(
        `/api/own-groups/${state.group.id}/users/?page=${page}`,
        config
      )
    ).data;
    commit("appendGroupUsers", data.results);
    commit("setGroupUsersMeta", {
      totalPages: Math.ceil(data.count / process.env.VUE_APP_PAGE_SIZE),
      pagesLoaded: page,
      search_query: search_query,
    });
  },

  async fetchGroupParticipants({ commit, state }) {
    let headers = {};
    headers["Authorization"] = `Bearer ${getToken()}`;
    let config = {};
    config["headers"] = headers;
    if (!getters.groupParticipantsHasMorePage) return;
    const page = state.groupParticipantsMeta.pagesLoaded + 1;
    const data = (
      await axios.get(
        `/api/groups/${state.group.id}/participants/?page=${page}`,
        config
      )
    ).data;
    commit("appendGroupParticipants", data.results);
    commit("setGroupParticipantsMeta", {
      totalPages: Math.ceil(data.count / process.env.VUE_APP_PAGE_SIZE),
      pagesLoaded: page,
    });
  },

  async fetchUpdates({ commit }) {
    let headers = {};
    headers["Authorization"] = `Bearer ${getToken()}`;
    let config = {};
    config["headers"] = headers;
    const data = (await axios.get(`/api/groups/updates/`, config)).data.results;
    commit("setUpdates", data);
  },

  async addAllFollowers({ commit }, { groupId }) {
    let headers = {};
    headers["Authorization"] = `Bearer ${getToken()}`;
    let config = {};
    config["headers"] = headers;
    const group = await axios.post(
      `/api/own-groups/${groupId}/add-all-followers/`,
      {},
      config
    );
    commit("updateOwnGroup", group);
  },
};

const mutations = {
  TOGGLE_GROUP_MODAL(state, obj) {
    state.group = obj;
  },
  addOwnGroup(state, value) {
    state.ownGroups.push(value);
  },

  removeOwnGroup(state, value) {
    const i = state.ownGroups.findIndex((group) => group.id === value);
    state.ownGroups.splice(i, 1);
  },

  setOwnGroups(state, value) {
    state.ownGroups = value;
  },

  updateOwnGroup(state, value) {
    const i = state.ownGroups.findIndex((group) => group.id === value.id);
    state.ownGroups[i] = value;

    if (state.group && state.group.id === value.id) state.group = value;
  },

  setUserId(state, value) {
    state.userId = value;
  },

  setUserGroups(state, value) {
    state.userGroups = value;
  },

  setGroup(state, value) {
    state.group = value;
    state.groupTrades = [];
    state.groupTradesMeta = {
      totalPages: 1,
      pagesLoaded: 0,
    };
    state.groupParticipants = [];
    state.groupParticipantsMeta = {
      totalPages: 1,
      pagesLoaded: 0,
    };
  },

  setGroupParticipationStatusTrue(state, obj) {
    state.group.is_participant = obj.state;
  },
  setGroupIsRequest(state, obj) {
    state.group.is_request = obj.state;
  },

  setGroupParticipationStatusFalse(state) {
    state.group.is_participant = false;
  },

  appendGroupTrades(state, value) {
    state.groupTrades = state.groupTrades.concat(value);
  },

  setGroupTradesMeta(state, value) {
    state.groupTradesMeta = value;
  },

  appendGroupUsers(state, value) {
    state.groupUsers = state.groupUsers.concat(value);
  },

  setGroupUsersMeta(state, value) {
    state.groupUsersMeta = value;
  },

  setGroupUsersMetaSearchQuery(state, value) {
    state.groupUsersMeta.search_query = value;
    state.groupUsersMeta.pagesLoaded = 0;
    state.groupUsersMeta.totalPages = 1;
  },

  appendGroupParticipants(state, value) {
    state.groupParticipants = state.groupParticipants.concat(value);
  },

  setGroupParticipantsMeta(state, value) {
    state.groupParticipantsMeta = value;
  },

  setUpdates(state, value) {
    state.updates = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
